import useFormatById from "src/hooks/utils/useFormatById";
import DefaultModal from "../defaultModal";
import { ReactComponent as SadFaceId } from "src/assets/static/icons/sad-face-id.svg";
import { ReactComponent as GreenSuccess } from "src/assets/static/icons/success-green.svg";
function BiometricAuthentificationsModal({
  handleActivate,
  showBiometricsAuthModal,
  handleHideBiometricsAuthModal,
  isSuccess,
  isRetry,
}) {
  const f = useFormatById();
  return (
    showBiometricsAuthModal && (
      <DefaultModal onClose={handleHideBiometricsAuthModal} size={"md"}>
        <div className="biometrics-modal-container">
          {isSuccess && (
            <>
              <GreenSuccess className="mt-5" />
              <div className="question-biometrics-modal">
                ბიომეტრიული ავტორიზაცია დაყენებულია
              </div>
            </>
          )}
          {isRetry && (
            <>
              <SadFaceId />
              <div className="question-biometrics-modal">
                ავტორიზაცია ვერ მოხერხდა
              </div>
              <div className="question-biometrics-modal-smaller">
                <div>სამწუხაროდ, ბიომეტრიული ავტორიზაცია ვერ მოხერხდა.</div>
                <div>სცადე კიდევ ერთხელ</div>
              </div>
              <div className="bts-biometrics-modal">
                <button
                  className="btn-biometrics-active"
                  onClick={handleActivate}
                >
                  ავტორიზაცია
                </button>
              </div>
            </>
          )}
        </div>
      </DefaultModal>
    )
  );
}

export default BiometricAuthentificationsModal;
